import { Pipe, PipeTransform } from "@angular/core";
import { IntlService } from "@progress/kendo-angular-intl";
import { TranslationsProvider } from "../../core/translations.provider";

/*
 * Replaces the format string placeholder with the provided value.
 * Usage:
 *   value | formatValue:format
 * Example:
 *   {{ 2 | formatValue:'{0:c}' }}
 *   formats to: $2
 */
@Pipe({ name: "formatDate" })
export class FormatDatePipe implements PipeTransform {
    culture = "en-GB";
    constructor(
        public intl: IntlService,
        public translation: TranslationsProvider
    ) {
        this.culture = translation.getCulture();
    }

    transform(value: any, culture: string, format: string): string {
        return this.intl.formatDate(
            value,
            format || "{0:d}",
            culture || this.culture
        );
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/pipes/format-date.pipe.ts